import PropTypes from 'prop-types';

import './SimpleSelect.css';

import { buildClass } from '../../libs/classes';

export const simpleSelectTypeCls = {
	default: 'type-default',
	thin: 'type-thin',
};

/**
 * This simple component represents a control that provides a menu of options
 * @component
 */
export const SimpleSelect = ({ value, title, className, onChange, tabIndex, children }) => {
	return (
		<select
			className={buildClass('simple-select').add(className, className, simpleSelectTypeCls.default)}
			tabIndex={tabIndex}
			title={title}
			value={value}
			onChange={onChange}
		>
			{children}
		</select>
	);
};

SimpleSelect.propTypes = {
	// Selected value
	value: PropTypes.string.isRequired,
	// Title html attribute for component
	title: PropTypes.string,
	// Additional class (can be object from buildClass)
	className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	// Callback function on change
	onChange: PropTypes.func.isRequired,
	// Tab index for the component
	tabIndex: PropTypes.number,
	// Select options nodes
	children: PropTypes.node.isRequired,
};

/**
 * This simple component represents a control that provides a menu of options prepended by label
 * @component
 */
export const SimpleSelectLabeled = ({ value, label, title, className, onChange, children }) => {
	return (
		<div className={buildClass('simple-select-labeled').add(className, className, simpleSelectTypeCls.default)}>
			<span className="label">{label}</span>
			<SimpleSelect className={className} title={title} value={value} onChange={onChange}>
				{children}
			</SimpleSelect>
		</div>
	);
};

SimpleSelectLabeled.propTypes = {
	// Selected value
	value: PropTypes.string.isRequired,
	// Label text
	label: PropTypes.string.isRequired,
	// Title html attribute for component
	title: PropTypes.string,
	// Additional class (can be object from buildClass)
	className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	// Callback function on change
	onChange: PropTypes.func,
	// Select options nodes
	children: PropTypes.node.isRequired,
};

export default SimpleSelect;
